import { TertiarynavMenu, TertiarynavMenuItem } from "components/navigation/tertiarynav";
import React from "react";
import { useFeature } from "store/selectors/hooks";

export const ManageIntegrationsNav: React.FC<unknown> = () => {
    const isWebhooksEnabled = useFeature("webhooks");

    return (
        <TertiarynavMenu>
            <TertiarynavMenuItem to="/settings/integrations/accounts">
                Accounts
            </TertiarynavMenuItem>
            <TertiarynavMenuItem to="/settings/integrations/quickbooks">
                QuickBooks
            </TertiarynavMenuItem>
            <TertiarynavMenuItem to="/settings/integrations/mailchimp">
                Mailchimp
            </TertiarynavMenuItem>
            <TertiarynavMenuItem to="/settings/integrations/constant-contact">
                Constant Contact
            </TertiarynavMenuItem>
            {isWebhooksEnabled && (
                <TertiarynavMenuItem to="/settings/integrations/webhooks">
                    Webhooks
                </TertiarynavMenuItem>
            )}
        </TertiarynavMenu>
    );
};
